// pages/Personal Attendance/DeptCoas.js
//   "Show All COA's of my Dept"     → defaultFuture = false
//   "Show Future COA's of my Dept"  → defaultFuture = true
// Backend: GET /api/coa/dept[?future=true]

import React from "react";
import { useLocation } from "react-router-dom";
import DeptAttendanceTable from "./components/DeptAttendanceTable";
import { getCoaDept } from "./ftoService";

const DeptCoas = () => {
    const loc = useLocation();
    const futureDefault = new URLSearchParams(loc.search).get("future") === "1";

    return (
        <DeptAttendanceTable
            title={futureDefault ? "Future COAs of My Dept" : "All COAs of My Dept"}
            subtitle="COAs from you and everyone who reports up to you"
            kind="COA"
            fetcher={getCoaDept}
            defaultFuture={futureDefault}
            breadcrumb={[{ label: "Attendance", to: "/workflows?wf=pac" }, { label: "Dept COAs" }]}
        />
    );
};

export default DeptCoas;
